export default {"src":"/_next/static/media/dhiFavicon.dcd40d95.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};